import { render } from "./AppointmentPage.vue?vue&type=template&id=539b780e&scoped=true&ts=true"
import script from "./AppointmentPage.vue?vue&type=script&lang=ts"
export * from "./AppointmentPage.vue?vue&type=script&lang=ts"

import "./AppointmentPage.vue?vue&type=style&index=0&id=539b780e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539b780e"]])

export default __exports__